import Blazy from "blazy";
import Flickity from "flickity";
import ScrollMagic from "ScrollMagic";
import googlemaps from "../comps/google-maps";
export default {
  init() {
    // JavaScript to be fired on all pages
    googlemaps.init();

    (function () {
      var touchingCarousel = false,
        touchStartCoords;

      document.body.addEventListener("touchstart", function (e) {
        if (e.target.closest(".flickity-slider")) {
          touchingCarousel = true;
        } else {
          touchingCarousel = false;
          return;
        }

        touchStartCoords = {
          x: e.touches[0].pageX,
          y: e.touches[0].pageY,
        };
      });

      document.body.addEventListener(
        "touchmove",
        function (e) {
          if (!(touchingCarousel && e.cancelable)) {
            return;
          }

          var moveVector = {
            x: e.touches[0].pageX - touchStartCoords.x,
            y: e.touches[0].pageY - touchStartCoords.y,
          };

          if (Math.abs(moveVector.x) > 7) e.preventDefault();
        },
        { passive: false }
      );
    })();

    var bLazy = new Blazy();
    const controller = new ScrollMagic.Controller();
    $("a").on("click", function (event) {
      // Make sure this.hash has a value before overriding default behavior
      if (this.hash !== "") {
        // Prevent default anchor click behavior
        event.preventDefault();

        // Store hash
        var hash = this.hash;

        // Using jQuery's animate() method to add smooth page scroll
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        $("html, body").animate(
          {
            scrollTop: $(hash).offset().top,
          },
          800,
          function () {
            // Add hash (#) to URL when done scrolling (default click behavior)
            window.location.hash = hash;
          }
        );
      } // End if
    });
    $(window).on("load", function () {
      bLazy;

      var carouselContainers = document.querySelectorAll(".slider-container");

      for (var i = 0; i < carouselContainers.length; i++) {
        var container = carouselContainers[i];
        initCarouselContainer(container);
      }

      function initCarouselContainer(container) {
        var carousel = container.querySelector(".slider");
        var flkty = new Flickity(carousel, {
          cellAlign: "left",
          contain: true,
          groupCells: true,
          accessibility: false,
          prevNextButtons: false,
          pageDots: true,
          fade: true,
          on: {
            ready: function () {
              bLazy.revalidate();
            },
            change: function () {
              setTimeout(function () {
                bLazy.revalidate();
              }, 500);
            },
          },
        });

        var previousButton = container.querySelector(
          ".slider-nav button.previous"
        );
        if (previousButton) {
          previousButton.addEventListener("click", function () {
            flkty.previous();
          });
        }

        var nextButton = container.querySelector(".slider-nav button.next");
        if (nextButton) {
          nextButton.addEventListener("click", function () {
            flkty.next();
          });
        }

        flkty.on("select", function (index) {
          var total = flkty.slides.length;
          if (index == 0) {
            previousButton.classList.add("disabled");
          } else {
            previousButton.classList.remove("disabled");
          }
          if (index + 1 == total) {
            nextButton.classList.add("disabled");
          } else {
            nextButton.classList.remove("disabled");
          }
          setTimeout(function () {
            bLazy.revalidate();
          }, 500);
        });
      }

      function footersize() {
        var height = 0;
        $(".footer-block").each(function() {
          var tempheight = $(this).height();
          if(tempheight > height) {
            height = tempheight;
          }

        }).promise().done( 
          $(".footer-block").height(height)
        );
      }
  
      footersize();
      $( window ).resize(function() {
        footersize();
      });

      if ($(".hero").length) {
        $(".global-nav a").each(function () {
          const $offset = $(window).height() - $(this).offset().top,
            $this = $(this);
          new ScrollMagic.Scene({
            triggerElement: $(".hero"),
            duration: $(document).outerHeight(),
            triggerHook: 0,
            offset: $offset,
          })
            .on("enter", function () {
              $this.addClass("text-black");
            })
            .on("leave", function () {
              $this.removeClass("text-black");
            })
            .addTo(controller);
        });
        const $offset = $(window).height() - $(".logo").offset().top,
          $this = $(".logo");
        new ScrollMagic.Scene({
          triggerElement: $(".hero"),
          duration: $(document).outerHeight(),
          triggerHook: 0,
          offset: $offset,
        })
          .on("enter", function () {
            $("body > header").addClass("text-black");
            $this.addClass("black");
          })
          .on("leave", function () {
            $("body > header").removeClass("text-black");
            $this.removeClass("black");
          })
          .addTo(controller);
      }
      $(".trigger-change").each(function () {
        var $this = $(this);
        new ScrollMagic.Scene({
          triggerElement: this,
          duration: $(this).outerHeight(),
          triggerHook: 0,
          offset: -$(window).height() / 2,
        })
          .on("enter leave", function () {
            var $index = $this.data("menu");
            $this.addClass("active");
            $(".global-nav a").removeClass("active");
            $(".global-nav a").eq($index).addClass("active");
          })
          .addTo(controller);
      });
      const $offset = $(window).height() - $(".logo").offset().top,
        $this = $(".logo");
      new ScrollMagic.Scene({
        triggerElement: $(".hero"),
        duration: $(document).outerHeight(),
        triggerHook: 0,
        offset: $offset,
      })
        .on("enter", function () {
          $this.addClass("black");
        })
        .on("leave", function () {
          $this.removeClass("black");
        })
        .addTo(controller);
      $(".global-nav a").each(function () {
        const $offset = $(".global-footer").offset().top - $(this).offset().top,
          $this = $(this);
        new ScrollMagic.Scene({
          triggerElement: $(".hero"),
          duration: $(document).outerHeight(),
          triggerHook: 0,
          offset: $offset,
        })
          .on("enter", function () {
            $this.removeClass("text-black");
          })
          .on("leave", function () {
            $this.addClass("text-black");
          })
          .addTo(controller);
      });
    });
    $(".reveal").click(function () {
      var content = $(this).siblings(".content");
      $(content).toggleClass("hidden");
      $(this).toggleClass("active");
      if ($(this).hasClass("active")) {
        $("html, body").animate(
          {
            scrollTop: $(this).parents().offset().top,
          },
          600
        );
      }
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js